<template>
  <!-- Основной layout приложения -->
  <UApp>
    <!-- Шапка приложения -->
    <UHeader>
      <!-- Левая часть - навигация -->
      <template #left>
        <UButton
          to="/"
          icon="i-lucide-arrow-left"
          aria-label="Главная"
          color="primary"
          variant="ghost"
        />
      </template>

      <!-- Правая часть - кнопки -->
      <template #right>
        <!-- Переключатель темы -->
        <UColorModeButton />

        <!-- Ссылка на резюме -->
        <UButton
          to="https://samara.hh.ru/resume/92300220ff0b96e53e0039ed1f6e5679364543"
          target="_blank"
          icon="i-simple-icons-github"
          aria-label="hh.ru"
          color="neutral"
          variant="ghost"
        />
      </template>
    </UHeader>

    <!-- Основная область контента -->
    <UMain>
      <NuxtPage />
    </UMain>

    <!-- Разделитель -->
    <USeparator icon="i-simple-icons-nuxtdotjs" />

    <!-- Подвал -->
    <UFooter>
      <!-- Левая часть - информация об авторе -->
      <template #left>
        <p class="text-sm text-muted">
          Built with Nuxt UI by Reon Kovalchuk • ©
          {{ new Date().getFullYear() }}
        </p>
      </template>

      <!-- Правая часть - ссылки -->
      <template #right>
        <UButton
          to="https://github.com/"
          target="_blank"
          icon="i-simple-icons-github"
          aria-label="GitHub"
          color="neutral"
          variant="ghost"
        />
      </template>
    </UFooter>
  </UApp>
</template>

<script setup>
// Основной компонент приложения - layout для всех страниц

useHead({
  meta: [{ name: "viewport", content: "width=device-width, initial-scale=1" }],
  link: [{ rel: "icon", href: "/favicon.ico" }],
  htmlAttrs: {
    lang: "ru",
  },
});

const title = "Заметки";
const description = "Тестовое задание Ковальчук Реон для МКК Луна";

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage:
    "https://sun9-83.userapi.com/s/v1/ig2/fz0BcsxA24ikOcBirujC8Hv2DWV_vT8PyZw0KB7ay3HY6GO3vJLQoiPIVLx3yLgSJi4khJuKMb189irhckRZxo-P.jpg?quality=95&as=32x21,48x32,72x48,108x72,160x107,240x160,360x240,480x320,540x360,640x427,720x480,1080x720,1280x853,1440x960,2560x1707&from=bu&cs=2560x0",
  twitterImage:
    "https://sun9-83.userapi.com/s/v1/ig2/fz0BcsxA24ikOcBirujC8Hv2DWV_vT8PyZw0KB7ay3HY6GO3vJLQoiPIVLx3yLgSJi4khJuKMb189irhckRZxo-P.jpg?quality=95&as=32x21,48x32,72x48,108x72,160x107,240x160,360x240,480x320,540x360,640x427,720x480,1080x720,1280x853,1440x960,2560x1707&from=bu&cs=2560x0",
  twitterCard: "summary_large_image",
});
</script>
